import { stenaStatisticsBar } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const RouteVolumeFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { routeVolume, setRouteVolume } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setRouteVolume({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return routeVolume.from || routeVolume.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"routeVolume"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaStatisticsBar}
      children={
        <RangeControl<RangeFilter>
          value={routeVolume}
          valueFrom={routeVolume.from}
          valueTo={routeVolume.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={6}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
